module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrRoman.8c8fd7a.woff2";